const marker = document.querySelector('script[data-ov-menu-loader]');
const desktopMenu = matchMedia('(min-width: 750px)');

const loadDesktopMenu = () => {
  if (!desktopMenu.matches || !marker) return;
  Promise.all([
    import(marker.dataset.overflowSource),
    import(marker.dataset.menuSource),
  ]).catch((error) => console.warn('[OLD VEGAS menu]', error));
};

desktopMenu.addEventListener('change', loadDesktopMenu);
loadDesktopMenu();
